import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import PropTypes from 'prop-types';
import classNames from 'classnames';

// Icons
import Icon from '@material-ui/core/Icon';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

// The `withStyles()` higher-order component is injecting a `classes`
// property that is used by the `Icon` component.
const CustomIcon = withStyles({
  root: {
    borderRadius: 5,
    border: 0,
    color: '#1958a7',
    width: 125,
  },
  label: {
    textTransform: 'capitalize',
  },
})(Icon);


class ProductSection extends React.Component {

  componentDidMount() {}

  render() {
    const { classes, data } = this.props;
    // Display max three dataBlocks. Added ID for those who want to appear
    const dataBlocks = data.filter(item => item.id === 0 || item.id === 1 || item.id === 2 );

    return (
      <div className={classes.section}>
        <div>
          <GridContainer>
            {dataBlocks.map(item =>
              <GridItem key={item.id} xs={12} sm={12} md={4}>

                <CustomIcon
                  className={classNames('fa', item.icon)}
                  color="primary"
                  fontSize="large"
                  style={{ fontSize: 65 }}
                  />

                <InfoArea
                  title={item.title}
                  description={item.body}
                  iconColor={item.icon_color}
                  vertical
                />
              </GridItem>
            )}
          </GridContainer>
        </div>
      </div>
    );
  }
}

ProductSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ProductSection.jsx